"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: offer/offer-details.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Foffer%2Foffer-details.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupRewardDetails = exports.PerkRewardDetails = exports.FundingRewardDetails = exports.TransactionFractionRewardDetails = exports.RewardDetails = exports.OfferDetails = exports.OfferForUser = void 0;
const amount_1 = require("../common/amount");
const tier_type_1 = require("../tier/tier-type");
const offer_config_1 = require("./offer-config");
const offer_content_1 = require("./offer-content");
const perk_partner_1 = require("./perk-partner");
const protobufPackage = 'com.step.offer.proto';
function createBaseOfferForUser() {
    return {
        offer: exports.OfferDetails.fromPartial({}),
        isEnrolled: false,
        isEligible: false,
        rewardCurrency: '',
        isAvailable: false,
        hasAvailableRewards: false,
        isBundle: false,
        isAutoEnrolled: false,
    };
}
exports.OfferForUser = {
    fromJSON(object) {
        const message = {
            offer: isSet(object.offer)
                ? exports.OfferDetails.fromJSON(object.offer)
                : exports.OfferDetails.fromPartial({}),
        };
        if (isSet(object.isEnrolled)) {
            message.isEnrolled = globalThis.Boolean(object.isEnrolled);
        }
        if (isSet(object.isEligible)) {
            message.isEligible = globalThis.Boolean(object.isEligible);
        }
        if (isSet(object.rewardCurrency)) {
            message.rewardCurrency = globalThis.String(object.rewardCurrency);
        }
        if (isSet(object.isAvailable)) {
            message.isAvailable = globalThis.Boolean(object.isAvailable);
        }
        if (isSet(object.hasAvailableRewards)) {
            message.hasAvailableRewards = globalThis.Boolean(object.hasAvailableRewards);
        }
        if (isSet(object.isBundle)) {
            message.isBundle = globalThis.Boolean(object.isBundle);
        }
        if (isSet(object.isAutoEnrolled)) {
            message.isAutoEnrolled = globalThis.Boolean(object.isAutoEnrolled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = exports.OfferDetails.toJSON(message.offer);
        }
        if (message.isEnrolled !== undefined && message.isEnrolled !== false) {
            obj.isEnrolled = message.isEnrolled;
        }
        if (message.isEligible !== undefined && message.isEligible !== false) {
            obj.isEligible = message.isEligible;
        }
        if (message.rewardCurrency !== undefined && message.rewardCurrency !== '') {
            obj.rewardCurrency = message.rewardCurrency;
        }
        if (message.isAvailable !== undefined && message.isAvailable !== false) {
            obj.isAvailable = message.isAvailable;
        }
        if (message.hasAvailableRewards !== undefined && message.hasAvailableRewards !== false) {
            obj.hasAvailableRewards = message.hasAvailableRewards;
        }
        if (message.isBundle !== undefined && message.isBundle !== false) {
            obj.isBundle = message.isBundle;
        }
        if (message.isAutoEnrolled !== undefined && message.isAutoEnrolled !== false) {
            obj.isAutoEnrolled = message.isAutoEnrolled;
        }
        return obj;
    },
    create(base) {
        return exports.OfferForUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferForUser();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? exports.OfferDetails.fromPartial(object.offer)
            : exports.OfferDetails.fromPartial({});
        message.isEnrolled = object.isEnrolled ?? false;
        message.isEligible = object.isEligible ?? false;
        message.rewardCurrency = object.rewardCurrency ?? '';
        message.isAvailable = object.isAvailable ?? false;
        message.hasAvailableRewards = object.hasAvailableRewards ?? false;
        message.isBundle = object.isBundle ?? false;
        message.isAutoEnrolled = object.isAutoEnrolled ?? false;
        return message;
    },
};
function createBaseOfferDetails() {
    return {
        id: '',
        code: '',
        name: '',
        description: '',
        startsAtMs: '0',
        expiresAtMs: '0',
        expiresInMs: '0',
        content: undefined,
        enrollmentGroup: offer_config_1.OfferEnrollmentGroup.fromPartial({}),
        rewards: [],
        ordinal: 0,
        tier: tier_type_1.TierType.INVALID_TIER,
        tiers: [],
        type: offer_config_1.OfferType.INVALID_SUB_TYPE,
    };
}
exports.OfferDetails = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            code: isSet(object.code) ? globalThis.String(object.code) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            enrollmentGroup: isSet(object.enrollmentGroup)
                ? offer_config_1.OfferEnrollmentGroup.fromJSON(object.enrollmentGroup)
                : offer_config_1.OfferEnrollmentGroup.fromPartial({}),
            type: isSet(object.type) ? (0, offer_config_1.offerTypeFromJSON)(object.type) : offer_config_1.OfferType.INVALID_SUB_TYPE,
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        if (isSet(object.startsAtMs)) {
            message.startsAtMs = globalThis.String(object.startsAtMs);
        }
        if (isSet(object.expiresAtMs)) {
            message.expiresAtMs = globalThis.String(object.expiresAtMs);
        }
        if (isSet(object.expiresInMs)) {
            message.expiresInMs = globalThis.String(object.expiresInMs);
        }
        if (isSet(object.content)) {
            message.content = offer_content_1.OfferContent.fromJSON(object.content);
        }
        if (globalThis.Array.isArray(object?.rewards)) {
            message.rewards = object.rewards.map((e) => exports.RewardDetails.fromJSON(e));
        }
        if (isSet(object.ordinal)) {
            message.ordinal = globalThis.Number(object.ordinal);
        }
        if (isSet(object.tier)) {
            message.tier = (0, tier_type_1.tierTypeFromJSON)(object.tier);
        }
        if (globalThis.Array.isArray(object?.tiers)) {
            message.tiers = object.tiers.map((e) => (0, tier_type_1.tierTypeFromJSON)(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.code !== '') {
            obj.code = message.code;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        if (message.startsAtMs !== undefined && message.startsAtMs !== '0') {
            obj.startsAtMs = message.startsAtMs;
        }
        if (message.expiresAtMs !== undefined && message.expiresAtMs !== '0') {
            obj.expiresAtMs = message.expiresAtMs;
        }
        if (message.expiresInMs !== undefined && message.expiresInMs !== '0') {
            obj.expiresInMs = message.expiresInMs;
        }
        if (message.content !== undefined) {
            obj.content = offer_content_1.OfferContent.toJSON(message.content);
        }
        if (message.enrollmentGroup !== undefined) {
            obj.enrollmentGroup = offer_config_1.OfferEnrollmentGroup.toJSON(message.enrollmentGroup);
        }
        if (message.rewards?.length) {
            obj.rewards = message.rewards.map((e) => exports.RewardDetails.toJSON(e));
        }
        if (message.ordinal !== undefined && message.ordinal !== 0) {
            obj.ordinal = Math.round(message.ordinal);
        }
        if (message.tier !== undefined && message.tier !== tier_type_1.TierType.INVALID_TIER) {
            obj.tier = (0, tier_type_1.tierTypeToJSON)(message.tier);
        }
        if (message.tiers?.length) {
            obj.tiers = message.tiers.map((e) => (0, tier_type_1.tierTypeToJSON)(e));
        }
        if (message.type !== offer_config_1.OfferType.INVALID_SUB_TYPE) {
            obj.type = (0, offer_config_1.offerTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.OfferDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferDetails();
        message.id = object.id ?? '';
        message.code = object.code ?? '';
        message.name = object.name ?? '';
        message.description = object.description ?? '';
        message.startsAtMs = object.startsAtMs ?? '0';
        message.expiresAtMs = object.expiresAtMs ?? '0';
        message.expiresInMs = object.expiresInMs ?? '0';
        message.content = (object.content !== undefined && object.content !== null)
            ? offer_content_1.OfferContent.fromPartial(object.content)
            : undefined;
        message.enrollmentGroup =
            (object.enrollmentGroup !== undefined && object.enrollmentGroup !== null)
                ? offer_config_1.OfferEnrollmentGroup.fromPartial(object.enrollmentGroup)
                : offer_config_1.OfferEnrollmentGroup.fromPartial({});
        message.rewards = object.rewards?.map((e) => exports.RewardDetails.fromPartial(e)) || [];
        message.ordinal = object.ordinal ?? 0;
        message.tier = object.tier ?? tier_type_1.TierType.INVALID_TIER;
        message.tiers = object.tiers?.map((e) => e) || [];
        message.type = object.type ?? offer_config_1.OfferType.INVALID_SUB_TYPE;
        return message;
    },
};
function createBaseRewardDetails() {
    return {
        id: '',
        maxTotalPayoutAmount: 0,
        maxPayoutCount: '0',
        transactionFraction: undefined,
        fundingReward: undefined,
        perkReward: undefined,
        signupReward: undefined,
        supportedRewardTypes: [],
    };
}
exports.RewardDetails = {
    fromJSON(object) {
        const message = { id: isSet(object.id) ? globalThis.String(object.id) : '' };
        if (isSet(object.maxTotalPayoutAmount)) {
            message.maxTotalPayoutAmount = globalThis.Number(object.maxTotalPayoutAmount);
        }
        if (isSet(object.maxPayoutCount)) {
            message.maxPayoutCount = globalThis.String(object.maxPayoutCount);
        }
        if (isSet(object.transactionFraction)) {
            message.transactionFraction = exports.TransactionFractionRewardDetails.fromJSON(object.transactionFraction);
        }
        if (isSet(object.fundingReward)) {
            message.fundingReward = exports.FundingRewardDetails.fromJSON(object.fundingReward);
        }
        if (isSet(object.perkReward)) {
            message.perkReward = exports.PerkRewardDetails.fromJSON(object.perkReward);
        }
        if (isSet(object.signupReward)) {
            message.signupReward = exports.SignupRewardDetails.fromJSON(object.signupReward);
        }
        if (globalThis.Array.isArray(object?.supportedRewardTypes)) {
            message.supportedRewardTypes = object.supportedRewardTypes.map((e) => globalThis.String(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.maxTotalPayoutAmount !== undefined && message.maxTotalPayoutAmount !== 0) {
            obj.maxTotalPayoutAmount = message.maxTotalPayoutAmount;
        }
        if (message.maxPayoutCount !== undefined && message.maxPayoutCount !== '0') {
            obj.maxPayoutCount = message.maxPayoutCount;
        }
        if (message.transactionFraction !== undefined) {
            obj.transactionFraction = exports.TransactionFractionRewardDetails.toJSON(message.transactionFraction);
        }
        if (message.fundingReward !== undefined) {
            obj.fundingReward = exports.FundingRewardDetails.toJSON(message.fundingReward);
        }
        if (message.perkReward !== undefined) {
            obj.perkReward = exports.PerkRewardDetails.toJSON(message.perkReward);
        }
        if (message.signupReward !== undefined) {
            obj.signupReward = exports.SignupRewardDetails.toJSON(message.signupReward);
        }
        if (message.supportedRewardTypes?.length) {
            obj.supportedRewardTypes = message.supportedRewardTypes;
        }
        return obj;
    },
    create(base) {
        return exports.RewardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRewardDetails();
        message.id = object.id ?? '';
        message.maxTotalPayoutAmount = object.maxTotalPayoutAmount ?? 0;
        message.maxPayoutCount = object.maxPayoutCount ?? '0';
        message.transactionFraction =
            (object.transactionFraction !== undefined && object.transactionFraction !== null)
                ? exports.TransactionFractionRewardDetails.fromPartial(object.transactionFraction)
                : undefined;
        message.fundingReward = (object.fundingReward !== undefined && object.fundingReward !== null)
            ? exports.FundingRewardDetails.fromPartial(object.fundingReward)
            : undefined;
        message.perkReward = (object.perkReward !== undefined && object.perkReward !== null)
            ? exports.PerkRewardDetails.fromPartial(object.perkReward)
            : undefined;
        message.signupReward = (object.signupReward !== undefined && object.signupReward !== null)
            ? exports.SignupRewardDetails.fromPartial(object.signupReward)
            : undefined;
        message.supportedRewardTypes = object.supportedRewardTypes?.map((e) => e) || [];
        return message;
    },
};
function createBaseTransactionFractionRewardDetails() {
    return { fraction: 0, minPurchaseAmount: 0 };
}
exports.TransactionFractionRewardDetails = {
    fromJSON(object) {
        const message = {
            fraction: isSet(object.fraction) ? globalThis.Number(object.fraction) : 0,
        };
        if (isSet(object.minPurchaseAmount)) {
            message.minPurchaseAmount = globalThis.Number(object.minPurchaseAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fraction !== 0) {
            obj.fraction = message.fraction;
        }
        if (message.minPurchaseAmount !== undefined && message.minPurchaseAmount !== 0) {
            obj.minPurchaseAmount = message.minPurchaseAmount;
        }
        return obj;
    },
    create(base) {
        return exports.TransactionFractionRewardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransactionFractionRewardDetails();
        message.fraction = object.fraction ?? 0;
        message.minPurchaseAmount = object.minPurchaseAmount ?? 0;
        return message;
    },
};
function createBaseFundingRewardDetails() {
    return { rewardAmount: 0 };
}
exports.FundingRewardDetails = {
    fromJSON(object) {
        const message = {
            rewardAmount: isSet(object.rewardAmount) ? globalThis.Number(object.rewardAmount) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewardAmount !== 0) {
            obj.rewardAmount = message.rewardAmount;
        }
        return obj;
    },
    create(base) {
        return exports.FundingRewardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingRewardDetails();
        message.rewardAmount = object.rewardAmount ?? 0;
        return message;
    },
};
function createBasePerkRewardDetails() {
    return {
        partner: perk_partner_1.PerkPartner.INVALID_PERK_PARTNER,
        promoCode: '',
        action: undefined,
        rewardStatus: undefined,
    };
}
exports.PerkRewardDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.partner)) {
            message.partner = (0, perk_partner_1.perkPartnerFromJSON)(object.partner);
        }
        if (isSet(object.promoCode)) {
            message.promoCode = globalThis.String(object.promoCode);
        }
        if (isSet(object.action)) {
            message.action = offer_config_1.PerkRewardAction.fromJSON(object.action);
        }
        if (isSet(object.rewardStatus)) {
            message.rewardStatus = globalThis.String(object.rewardStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.partner !== undefined && message.partner !== perk_partner_1.PerkPartner.INVALID_PERK_PARTNER) {
            obj.partner = (0, perk_partner_1.perkPartnerToJSON)(message.partner);
        }
        if (message.promoCode !== undefined && message.promoCode !== '') {
            obj.promoCode = message.promoCode;
        }
        if (message.action !== undefined) {
            obj.action = offer_config_1.PerkRewardAction.toJSON(message.action);
        }
        if (message.rewardStatus !== undefined) {
            obj.rewardStatus = message.rewardStatus;
        }
        return obj;
    },
    create(base) {
        return exports.PerkRewardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePerkRewardDetails();
        message.partner = object.partner ?? perk_partner_1.PerkPartner.INVALID_PERK_PARTNER;
        message.promoCode = object.promoCode ?? '';
        message.action = (object.action !== undefined && object.action !== null)
            ? offer_config_1.PerkRewardAction.fromPartial(object.action)
            : undefined;
        message.rewardStatus = object.rewardStatus ?? undefined;
        return message;
    },
};
function createBaseSignupRewardDetails() {
    return { rewardAmount: amount_1.Amount.fromPartial({}) };
}
exports.SignupRewardDetails = {
    fromJSON(object) {
        const message = {
            rewardAmount: isSet(object.rewardAmount)
                ? amount_1.Amount.fromJSON(object.rewardAmount)
                : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rewardAmount !== undefined) {
            obj.rewardAmount = amount_1.Amount.toJSON(message.rewardAmount);
        }
        return obj;
    },
    create(base) {
        return exports.SignupRewardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSignupRewardDetails();
        message.rewardAmount = (object.rewardAmount !== undefined && object.rewardAmount !== null)
            ? amount_1.Amount.fromPartial(object.rewardAmount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=offer-details.js.map